module.exports = __webpack_public_path__ + "img/vi-box4-text-dark.7cb566c1.png";